function addAltText_2f28fc91ae0840088f2beb0bd82fd0b2() {
  const altTextMap = [
    [
      '.lyvecom_carousel-component >> div[data-story-id="65e66089983763430acea7f4"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="65e66089983763430acea7f4"] > .cover-image[loading="lazy"]',
        alt: "Person holding a brown bottle with a dropper labeled 'Nemah'.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6504b430e0ed27bba405ccdd"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6504b430e0ed27bba405ccdd"] > .cover-image[loading="lazy"]',
        alt: "Pregnant person in a lace dress smiling and holding their belly.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6567629865222bf41893c21e"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6567629865222bf41893c21e"] > .cover-image[loading="lazy"]',
        alt: "Person applying a product from a roller bottle onto their hand.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6504bb7ca05ed2b2c94e4339"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6504bb7ca05ed2b2c94e4339"] > .cover-image[loading="lazy"]',
        alt: "Pregnant person in brown clothing holding their belly, with text 'Nourishing Mama Duo'.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="65139c56a83241ed89ecb04d"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="65139c56a83241ed89ecb04d"] > .cover-image[loading="lazy"]',
        alt: "Person holding a brown box labeled 'Nemah' with text about donations to Every Mother Counts.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64db06a94b143c920c68683f"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64db06a94b143c920c68683f"] > .cover-image[loading="lazy"]',
        alt: "Person holding a white tube labeled 'Nemah' with a smile.",
      },
    ],
    [
      ".lyvecom_carousel-component >> .swiper-button-next",
      {
        selector: ".lyvecom_carousel-component >> .swiper-button-next",
        alt: "White circle with a black arrow pointing right.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="651ad59287391b60f4e664ec"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="651ad59287391b60f4e664ec"] > .cover-image[loading="lazy"]',
        alt: "Person holding a tube labeled 'Nemah' with text about reducing stretch marks.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="651b10d3ac50ad5b1a5e4232"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="651b10d3ac50ad5b1a5e4232"] > .cover-image[loading="lazy"]',
        alt: "Person holding a baby, with text about Nemah and peppermint ginger tea.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64daae7fe9ace09cff473d3f"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64daae7fe9ace09cff473d3f"] > .cover-image[loading="lazy"]',
        alt: "Person holding a Nemah product tube, looking at the camera.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64dab0bfb661fa88ce6013c6"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64dab0bfb661fa88ce6013c6"] > .cover-image[loading="lazy"]',
        alt: "Hand holding a tube of cream labeled 'nemah' on a wooden surface.",
      },
    ],
  ];
  const selectorRouteMap = {
    '.lyvecom_carousel-component >> div[data-story-id="65e66089983763430acea7f4"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6504b430e0ed27bba405ccdd"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6567629865222bf41893c21e"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6504bb7ca05ed2b2c94e4339"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="65139c56a83241ed89ecb04d"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64db06a94b143c920c68683f"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    ".lyvecom_carousel-component >> .swiper-button-next": ["https://nemah.com/"],
    '.lyvecom_carousel-component >> div[data-story-id="651ad59287391b60f4e664ec"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="651b10d3ac50ad5b1a5e4232"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64daae7fe9ace09cff473d3f"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    ".lyvecom_widget >> .minimized_cut_icon": ["https://nemah.com/"],
    '.lyvecom_carousel-component >> div[data-story-id="651df6fd8354c435f822a279"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="65139a648cf4a5023c154c3b"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64dab0bfb661fa88ce6013c6"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
  };

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split(">>").map((s) => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter((el) => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some((route) => {
      const routeRegex = new RegExp("^" + route.replace(/\*/g, ".*") + "$");
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if (img instanceof HTMLImageElement && (!img.alt || img.alt === "")) {
          img.alt = value.alt;
          img.setAttribute("data-alt-added", "2f28fc91ae0840088f2beb0bd82fd0b2");
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", addAltText_2f28fc91ae0840088f2beb0bd82fd0b2);
} else {
  addAltText_2f28fc91ae0840088f2beb0bd82fd0b2();
}

// Rerun the function when the DOM changes
const observer_2f28fc91ae0840088f2beb0bd82fd0b2 = new MutationObserver(() => {
  addAltText_2f28fc91ae0840088f2beb0bd82fd0b2();
});
observer_2f28fc91ae0840088f2beb0bd82fd0b2.observe(document.body, { childList: true, subtree: true });

function fixAccessibility_fed6e758b7914ff39a5c5af4ee02931e() {
  const selectors = [
    '.revitalizing-stretch-mark-cream > .rebuy-product-info > .rebuy-product-title.clickable[aria-level="5"]',
    'a[aria-label="View Pregnancy Set"][aria-level="5"]',
    '.calming-aromatherapy-roll-on > .rebuy-product-info > .rebuy-product-title.clickable[aria-level="5"]',
  ];

  const interval = setInterval(() => {
    let allFixed = true;

    selectors.forEach((selector) => {
      const elements = document.querySelectorAll(selector);
      elements.forEach((element) => {
        if (element.hasAttribute("aria-level")) {
          element.removeAttribute("aria-level");
          element.setAttribute("data-accessibility-fix", "fed6e758b7914ff39a5c5af4ee02931e");
          console.log(`Fixed accessibility issue for element: ${element.outerHTML}`);
        }
      });
      if (document.querySelector(selector)) {
        allFixed = false;
      }
    });

    if (allFixed) {
      clearInterval(interval);
    }
  }, 1000);

  // PostMessage for cross-origin iframes
  window.addEventListener("message", (event) => {
    if (event.data === "fixAccessibility_fed6e758b7914ff39a5c5af4ee02931e") {
      selectors.forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((element) => {
          if (element.hasAttribute("aria-level")) {
            element.removeAttribute("aria-level");
            element.setAttribute("data-accessibility-fix", "fed6e758b7914ff39a5c5af4ee02931e");
            console.log(`Fixed accessibility issue for element in iframe: ${element.outerHTML}`);
          }
        });
      });
    }
  });

  // Notify iframes to fix accessibility issues
  const iframes = document.querySelectorAll("iframe");
  iframes.forEach((iframe) => {
    iframe.contentWindow.postMessage("fixAccessibility_fed6e758b7914ff39a5c5af4ee02931e", "*");
  });
}

fixAccessibility_fed6e758b7914ff39a5c5af4ee02931e();

function fixAccessibility_5e650ba6ce7b4c4090b90fe53028d029() {
  let intervalId = setInterval(() => {
    try {
      const metaElement = document.querySelector('meta[name="viewport"]:nth-child(118)');
      if (metaElement && metaElement.content.includes("user-scalable=0")) {
        metaElement.content = metaElement.content.replace(/user-scalable=0/, "user-scalable=yes");
        metaElement.setAttribute("data-accessibility-fix", "5e650ba6ce7b4c4090b90fe53028d029");
        console.log("Accessibility fix applied: user-scalable set to yes");
        clearInterval(intervalId);
      }
    } catch (error) {
      console.error("Error applying accessibility fix:", error);
    }
  }, 1000);
}

fixAccessibility_5e650ba6ce7b4c4090b90fe53028d029();

function fixAccessibility_d9a710ebd9de47129bd621b6b4e64dff() {
  const interval = setInterval(() => {
    const elements = document.querySelectorAll(".junip-label-container");
    let allFixed = true;

    elements.forEach((element) => {
      const ariaControls = element.getAttribute("aria-controls");
      if (ariaControls === "junip-filters-container") {
        try {
          const targetElement = document.getElementById(ariaControls);
          if (targetElement) {
            element.setAttribute("data-accessibility-fix", "d9a710ebd9de47129bd621b6b4e64dff");
            allFixed = false;
          } else {
            console.warn(`Element with id ${ariaControls} not found. Cannot fix ARIA attribute for`, element);
          }
        } catch (error) {
          console.error("Error fixing accessibility issue:", error);
        }
      }
    });

    if (allFixed) {
      clearInterval(interval);
    }
  }, 1000);
}

fixAccessibility_d9a710ebd9de47129bd621b6b4e64dff();

function fixAccessibility_f7e2448a12bc4503a181f3edfcd1717b() {
  const interval = setInterval(() => {
    const buttons = document.querySelectorAll(".rc-subscription-details__button");
    let allFixed = true;

    buttons.forEach((button) => {
      if (!button.hasAttribute("aria-label") || button.getAttribute("aria-label").trim() === "") {
        button.setAttribute("aria-label", "Subscription Details");
        button.setAttribute("data-accessibility-fix", "f7e2448a12bc4503a181f3edfcd1717b");
        console.log("Fixed accessibility issue for button:", button);
      } else {
        allFixed = false;
      }
    });

    if (allFixed) {
      clearInterval(interval);
    }
  }, 1000);

  window.addEventListener(
    "message",
    (event) => {
      if (event.data === "fixAccessibility_f7e2448a12bc4503a181f3edfcd1717b") {
        fixAccessibility_f7e2448a12bc4503a181f3edfcd1717b();
      }
    },
    false
  );
}

fixAccessibility_f7e2448a12bc4503a181f3edfcd1717b();

function fixAccessibility_df147dcaaf304fe5acd3893c32217ed8() {
  const interval = setInterval(() => {
    try {
      const metaTags = document.querySelectorAll('meta[name="viewport"][content*="maximum-scale"]');
      let allFixed = true;

      metaTags.forEach((meta) => {
        const content = meta.getAttribute("content");
        if (content.includes("maximum-scale=1.0") || content.includes("user-scalable=0")) {
          const newContent = content.replace(/maximum-scale=1.0,?\s*/g, "").replace(/user-scalable=0,?\s*/g, "");
          meta.setAttribute("content", newContent);
          meta.setAttribute("data-accessibility-fix", "df147dcaaf304fe5acd3893c32217ed8");
          console.log("Fixed accessibility issue for viewport meta tag:", meta);
        } else {
          allFixed = false;
        }
      });

      if (allFixed) {
        clearInterval(interval);
      }
    } catch (error) {
      console.error("Error fixing accessibility issue:", error);
    }
  }, 1000);
}

fixAccessibility_df147dcaaf304fe5acd3893c32217ed8();

function fixAccessibility_d2faf539c6bc466e9e3752d6d454c842() {
  const interval = setInterval(() => {
    const link = document.querySelector(".rc-login--header-link");
    if (
      link &&
      !link.hasAttribute("aria-label") &&
      !link.hasAttribute("aria-labelledby") &&
      !link.hasAttribute("title")
    ) {
      try {
        // Adding aria-label to provide accessible text to screen readers
        link.setAttribute("aria-label", "Recharge Payments");
        // Marking the element with a data attribute for identification
        link.setAttribute("data-accessibility-fix", "d2faf539c6bc466e9e3752d6d454c842");
        console.log("Accessibility fix applied to .rc-login--header-link");
        clearInterval(interval);
      } catch (error) {
        console.error("Error applying accessibility fix:", error);
      }
    }
  }, 1000);
}

fixAccessibility_d2faf539c6bc466e9e3752d6d454c842();

function addAltText_1d966d9641f64199afa46a2eff2adfe1() {
  const altTextMap = [
    [
      '.lyvecom_carousel-component >> div[data-story-id="6504b430e0ed27bba405ccdd"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6504b430e0ed27bba405ccdd"] > .cover-image[loading="lazy"]',
        alt: "Pregnant woman in a lace dress smiling and holding her belly.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="65139a648cf4a5023c154c3b"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="65139a648cf4a5023c154c3b"] > .cover-image[loading="lazy"]',
        alt: "Adult's hand gently brushing a child's hair with text overlay about finding shampoo.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6504bb7ca05ed2b2c94e4339"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6504bb7ca05ed2b2c94e4339"] > .cover-image[loading="lazy"]',
        alt: "Pregnant woman in a brown outfit holding her belly in a bathroom.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64db07745a643d6c80fb9b17"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64db07745a643d6c80fb9b17"] > .cover-image[loading="lazy"]',
        alt: "Elegant bathroom with a freestanding tub, towels, and a chandelier.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6567629865222bf41893c21e"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6567629865222bf41893c21e"] > .cover-image[loading="lazy"]',
        alt: "Person applying a skincare product from a roller tube onto their hand.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="65139f7a9b28eef1f5e4794b"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="65139f7a9b28eef1f5e4794b"] > .cover-image[loading="lazy"]',
        alt: "Baby's feet resting on a blanket with a soft toy in the background.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64daadbde605c8083bb8a9a0"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64daadbde605c8083bb8a9a0"] > .cover-image[loading="lazy"]',
        alt: "Person holding a tube of skincare product with the brand name 'Nemah' visible.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6569053941c78b5bb26a5861"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6569053941c78b5bb26a5861"] > .cover-image[loading="lazy"]',
        alt: "Hands holding a brown box with the brand name 'Nemah' on it.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64db06302226c781e3ccbfd4"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64db06302226c781e3ccbfd4"] > .cover-image[loading="lazy"]',
        alt: "Person squeezing a tube of cream into their hand.",
      },
    ],
    [
      ".lyvecom_carousel-component >> .swiper-button-next",
      {
        selector: ".lyvecom_carousel-component >> .swiper-button-next",
        alt: "White circular button with a right arrow symbol.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64db03fb14dc391379c3b2ed"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64db03fb14dc391379c3b2ed"] > .cover-image[loading="lazy"]',
        alt: "Person holding a jar of Nēmah skincare product.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64daaa7d49818ddf5237a340"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64daaa7d49818ddf5237a340"] > .cover-image[loading="lazy"]',
        alt: "Close-up of hands holding a Nēmah skincare product box with text 'A self care moment with Nēmah'.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64daa913898479787a4e9df5"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64daa913898479787a4e9df5"] > .cover-image[loading="lazy"]',
        alt: "Open Nēmah package with a thank you note inside.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64daafcb7bd7bc4df76c5626"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64daafcb7bd7bc4df76c5626"] > .cover-image[loading="lazy"]',
        alt: "Person applying Nēmah skincare product to their abdomen.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64daa0c7a38c5faa54f98c46"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64daa0c7a38c5faa54f98c46"] > .cover-image[loading="lazy"]',
        alt: "Two Nēmah skincare tubes on a textured surface.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64da66026d984c38e115e744"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64da66026d984c38e115e744"] > .cover-image[loading="lazy"]',
        alt: "Nēmah package on a bedside table with decorative items and books.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64da9c03f3c842cf570437cb"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64da9c03f3c842cf570437cb"] > .cover-image[loading="lazy"]',
        alt: "Person with long hair standing in a doorway, facing away.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64dab27d9d0d1a8acb0078d2"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64dab27d9d0d1a8acb0078d2"] > .cover-image[loading="lazy"]',
        alt: "Hand reaching for a Nēmah skincare bottle next to a decorative vase.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="65677134d136ef13701198cf"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="65677134d136ef13701198cf"] > .cover-image[loading="lazy"]',
        alt: "Person holding a Nēmah skincare bottle with descriptive text overlay.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64da9cf5e8754cfba4e6b307"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64da9cf5e8754cfba4e6b307"] > .cover-image[loading="lazy"]',
        alt: "Person applying Nēmah skincare product to their abdomen with text overlay.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6504b64fa2b8d5ddf36e823b"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6504b64fa2b8d5ddf36e823b"] > .cover-image[loading="lazy"]',
        alt: "Hand holding a box of Nemah revitalizing stretch mark cream.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6504bba5355389b3ecd4966a"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6504bba5355389b3ecd4966a"] > .cover-image[loading="lazy"]',
        alt: "Hand holding a tube of Nemah revitalizing stretch mark cream next to a lit candle on a marble surface.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64daae7fe9ace09cff473d3f"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64daae7fe9ace09cff473d3f"] > .cover-image[loading="lazy"]',
        alt: "Person holding a tube of Nemah cream, smiling at the camera.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="651df6fd8354c435f822a279"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="651df6fd8354c435f822a279"] > .cover-image[loading="lazy"]',
        alt: "Person in a bathroom pointing while discussing their favorite pregnancy cream.",
      },
    ],
    [
      ".video-hero__video > img",
      {
        selector: ".video-hero__video > img",
        alt: "Tube of Nemah revitalizing stretch mark cream on a wooden surface.",
      },
    ],
  ];
  const selectorRouteMap = {
    '.lyvecom_carousel-component >> div[data-story-id="6504b430e0ed27bba405ccdd"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="65139a648cf4a5023c154c3b"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6504bb7ca05ed2b2c94e4339"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64db07745a643d6c80fb9b17"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6567629865222bf41893c21e"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="65139f7a9b28eef1f5e4794b"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64daadbde605c8083bb8a9a0"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6569053941c78b5bb26a5861"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64db06302226c781e3ccbfd4"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    ".lyvecom_carousel-component >> .swiper-button-next": [
      "https://nemah.com/pages/baby-shower",
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64db03fb14dc391379c3b2ed"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64daaa7d49818ddf5237a340"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64daa913898479787a4e9df5"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64daafcb7bd7bc4df76c5626"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64daa0c7a38c5faa54f98c46"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64da66026d984c38e115e744"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64da9c03f3c842cf570437cb"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64dab27d9d0d1a8acb0078d2"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="65677134d136ef13701198cf"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64da9cf5e8754cfba4e6b307"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6504b64fa2b8d5ddf36e823b"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6504bba5355389b3ecd4966a"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64daae7fe9ace09cff473d3f"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/baby-shower",
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="651df6fd8354c435f822a279"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/",
      "https://nemah.com/products/revitalizing-stretch-mark-cream",
    ],
    ".video-hero__video > img": ["https://nemah.com/products/revitalizing-stretch-mark-cream"],
  };

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split(">>").map((s) => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter((el) => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some((route) => {
      const routeRegex = new RegExp("^" + route.replace(/\*/g, ".*") + "$");
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if (img instanceof HTMLImageElement && (!img.alt || img.alt === "")) {
          img.alt = value.alt;
          img.setAttribute("data-alt-added", "1d966d9641f64199afa46a2eff2adfe1");
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", addAltText_1d966d9641f64199afa46a2eff2adfe1);
} else {
  addAltText_1d966d9641f64199afa46a2eff2adfe1();
}

// Rerun the function when the DOM changes
const observer_1d966d9641f64199afa46a2eff2adfe1 = new MutationObserver(() => {
  addAltText_1d966d9641f64199afa46a2eff2adfe1();
});
observer_1d966d9641f64199afa46a2eff2adfe1.observe(document.body, { childList: true, subtree: true });

function fixAccessibility_124ee3011e94475d9f85ea7907c92adb() {
  const targetArray = [
    {
      outerSelector: ".kl-teaser-SgFRMV",
      innerSelector: "BUTTON.needsclick.klaviyo-close-form.go1982198487.kl-private-reset-css-Xuajs1",
    },
  ];

  const interval = setInterval(() => {
    try {
      for (const target of targetArray) {
        const outerElements = document.querySelectorAll(target.outerSelector);

        outerElements.forEach((outerElement) => {
          const innerElements = outerElement.querySelectorAll(target.innerSelector);

          innerElements.forEach((innerElement) => {
            // Collect ancestor elements between outerElement and innerElement
            let currentElement = innerElement.parentElement;
            const ancestorElements = [];

            while (currentElement && currentElement !== outerElement) {
              ancestorElements.unshift(currentElement);
              currentElement = currentElement.parentElement;
            }

            // Create corresponding new ancestor elements
            const newAncestors = ancestorElements.map((originalElement) => {
              const newElement = document.createElement(originalElement.tagName);

              // Copy attributes
              Array.from(originalElement.attributes).forEach((attr) => {
                newElement.setAttribute(attr.name, attr.value);
              });

              // Copy positioning styles
              copyPositioningStyles(originalElement, newElement);

              return newElement;
            });

            // Create the wrapper
            const wrapper = document.createElement("div");
            wrapper.style.position = "relative";

            // Copy positioning styles from outerElement to wrapper
            copyPositioningStyles(outerElement, wrapper);

            // Reset positioning styles on outerElement
            resetPositioningStyles(outerElement);

            // Insert wrapper before outerElement
            outerElement.parentNode.insertBefore(wrapper, outerElement);

            // Move outerElement into wrapper
            wrapper.appendChild(outerElement);

            // Rebuild ancestor hierarchy in wrapper
            let currentParent = wrapper;
            newAncestors.forEach((newAncestor) => {
              currentParent.appendChild(newAncestor);
              currentParent = newAncestor;
            });

            // Move innerElement into the deepest new ancestor
            currentParent.appendChild(innerElement);

            // Reset positioning styles on original ancestors
            ancestorElements.forEach((originalElement) => {
              resetPositioningStyles(originalElement);
            });

            // Mark as fixed
            outerElement.setAttribute("data-accessibility-fix", "124ee3011e94475d9f85ea7907c92adb");

            console.log("Accessibility fix applied to", outerElement);
          });
        });
      }
    } catch (error) {
      console.error("Error applying accessibility fix:", error);
      clearInterval(interval);
    }
  }, 1000);
}

function copyPositioningStyles(sourceElement, targetElement) {
  const positioningStyles = [
    "position",
    "top",
    "left",
    "right",
    "bottom",
    "zIndex",
    "transform",
    "width",
    "height",
    "margin",
    "padding",
    // Add other relevant styles if necessary
  ];

  const computedStyle = window.getComputedStyle(sourceElement);
  positioningStyles.forEach((style) => {
    targetElement.style[style] = computedStyle.getPropertyValue(style);
  });
}

function resetPositioningStyles(element) {
  const positioningStyles = [
    "position",
    "top",
    "left",
    "right",
    "bottom",
    "zIndex",
    "transform",
    "margin",
    "padding",
    // Add other relevant styles if necessary
  ];
  positioningStyles.forEach((style) => {
    element.style[style] = "";
  });
}

fixAccessibility_124ee3011e94475d9f85ea7907c92adb();

function fixAccessibility_dc21c72b61974adaaf0668a68a684e3e() {
  const intervalId = setInterval(() => {
    const elements = document.querySelectorAll(".junip-label-container");
    let allFixed = false;

    elements.forEach((element) => {
      if (element.getAttribute("aria-controls") === "junip-filters-container") {
        try {
          // Check if the element has the aria-controls attribute with invalid value
          element.removeAttribute("aria-controls");
          element.setAttribute("data-accessibility-fix", "dc21c72b61974adaaf0668a68a684e3e");
        } catch (error) {
          console.error("Error fixing accessibility issue:", error);
        }
      }

      // Check if the fix is applied
      if (element.getAttribute("data-accessibility-fix") === "dc21c72b61974adaaf0668a68a684e3e") {
        allFixed = true;
      }
    });

    if (allFixed) {
      clearInterval(intervalId);
    }
  }, 1000);
}

fixAccessibility_dc21c72b61974adaaf0668a68a684e3e();

function addAltText_f878e28d6ba14a9cb850bd413724ea46() {
  const altTextMap = [
    [
      'shop-login-button >> shop-follow-button >> follow-on-shop-button >> shop-logo[color="white"] >> svg[width="38"][viewBox="0 0 65 26"][aria-labelledby="shop-logo"]',
      {
        selector:
          'shop-login-button >> shop-follow-button >> follow-on-shop-button >> shop-logo[color="white"] >> svg[width="38"][viewBox="0 0 65 26"][aria-labelledby="shop-logo"]',
        alt: "Logo with stylized letters forming the word 'Shop' in a unique font style.",
      },
    ],
    [
      'shop-login-button[action="follow"] >> shop-follow-button >> follow-on-shop-button >> shop-logo[color="white"] >> svg[width="38"][height="15"][viewBox="0 0 65 26"]',
      {
        selector:
          'shop-login-button[action="follow"] >> shop-follow-button >> follow-on-shop-button >> shop-logo[color="white"] >> svg[width="38"][height="15"][viewBox="0 0 65 26"]',
        alt: "Stylized logo with abstract shapes and curves, representing a modern design.",
      },
    ],
  ];
  const selectorRouteMap = {
    'shop-login-button >> shop-follow-button >> follow-on-shop-button >> shop-logo[color="white"] >> svg[width="38"][viewBox="0 0 65 26"][aria-labelledby="shop-logo"]':
      [
        "https://nemah.com/",
        "https://nemah.com/blogs/all-blogs/kourtney-kardashian-includes-nemah-in-her-hospital-bag",
        "https://nemah.com/collections/all",
        "https://nemah.com/pages/baby-shower",
        "https://nemah.com/products/revitalizing-stretch-mark-cream",
        "https://nemah.com/search",
        "https://nemah.com/policies/shipping-policy",
        "https://nemah.com/tools/recurring/get-subscription-access",
      ],
    'shop-login-button[action="follow"] >> shop-follow-button >> follow-on-shop-button >> shop-logo[color="white"] >> svg[width="38"][height="15"][viewBox="0 0 65 26"]':
      ["https://nemah.com/account/login"],
  };

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split(">>").map((s) => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter((el) => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some((route) => {
      const routeRegex = new RegExp("^" + route.replace(/\*/g, ".*") + "$");
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if ((img instanceof HTMLImageElement || img instanceof SVGElement) && (!img.alt || img.alt === "")) {
          img.role = "img";
          img.setAttribute("aria-label", value.alt);

          img.setAttribute("data-alt-added", "f878e28d6ba14a9cb850bd413724ea46");
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", addAltText_f878e28d6ba14a9cb850bd413724ea46);
} else {
  addAltText_f878e28d6ba14a9cb850bd413724ea46();
}

// Rerun the function when the DOM changes
const observer_f878e28d6ba14a9cb850bd413724ea46 = new MutationObserver(() => {
  addAltText_f878e28d6ba14a9cb850bd413724ea46();
});
observer_f878e28d6ba14a9cb850bd413724ea46.observe(document.body, { childList: true, subtree: true });
function addAltText_fa31c2239fb14d6e8a4b32af7f3968d8() {
  const altTextMap = [
    [
      '.lyvecom_carousel-component >> div[data-story-id="64daae7fe9ace09cff473d3f"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64daae7fe9ace09cff473d3f"] > .cover-image[loading="lazy"]',
        alt: "Person holding a product labeled 'Nemah' with a neutral expression.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="64dab0bfb661fa88ce6013c6"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="64dab0bfb661fa88ce6013c6"] > .cover-image[loading="lazy"]',
        alt: "Hand holding a tube of Nemah product on a wooden surface.",
      },
    ],
    [
      ".intro__item.flex-col.justify-center:nth-child(3) > .intro__item-icon.overflow-hidden > .intro__item-icon-img",
      {
        selector:
          ".intro__item.flex-col.justify-center:nth-child(3) > .intro__item-icon.overflow-hidden > .intro__item-icon-img",
        alt: "Simple line drawing of a box with a cross on top.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6504bb7ca05ed2b2c94e4339"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6504bb7ca05ed2b2c94e4339"] > .cover-image[loading="lazy"]',
        alt: "Pregnant person in a brown outfit holding their belly, with text 'Nourishing Mama Duo' overlaid.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="65e66089983763430acea7f4"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="65e66089983763430acea7f4"] > .cover-image[loading="lazy"]',
        alt: "Hands holding a dropper and a bottle labeled 'Nemah' with text 'Self Care with Nemah' overlaid.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="651b10d3ac50ad5b1a5e4232"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="651b10d3ac50ad5b1a5e4232"] > .cover-image[loading="lazy"]',
        alt: "Person holding a baby with text about Nemah and tea product overlaid.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="651df6fd8354c435f822a279"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="651df6fd8354c435f822a279"] > .cover-image[loading="lazy"]',
        alt: "Person in a floral outfit talking about pregnancy cream, with text overlay.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="6504b430e0ed27bba405ccdd"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="6504b430e0ed27bba405ccdd"] > .cover-image[loading="lazy"]',
        alt: "Pregnant person in a lace dress smiling and holding their belly.",
      },
    ],
    [
      '.lyvecom_carousel-component >> div[data-story-id="65139c56a83241ed89ecb04d"] > .cover-image[loading="lazy"]',
      {
        selector:
          '.lyvecom_carousel-component >> div[data-story-id="65139c56a83241ed89ecb04d"] > .cover-image[loading="lazy"]',
        alt: "Person holding a Nemah box with text about donations and a discount offer.",
      },
    ],
    [
      ".lyvecom_carousel-component >> .swiper-button-next",
      {
        selector: ".lyvecom_carousel-component >> .swiper-button-next",
        alt: "White circle with a black arrow pointing right inside it.",
      },
    ],
    [
      ".intro__item.flex-col.justify-center:nth-child(2) > .intro__item-icon.overflow-hidden > .intro__item-icon-img",
      {
        selector:
          ".intro__item.flex-col.justify-center:nth-child(2) > .intro__item-icon.overflow-hidden > .intro__item-icon-img",
        alt: "Icon of a camera with horizontal lines above it, resembling a simplified camera design.",
      },
    ],
  ];
  const selectorRouteMap = {
    '.lyvecom_carousel-component >> div[data-story-id="64daae7fe9ace09cff473d3f"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64dab0bfb661fa88ce6013c6"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    ".intro__item.flex-col.justify-center:nth-child(3) > .intro__item-icon.overflow-hidden > .intro__item-icon-img": [
      "https://nemah.com/pages/rewards",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6504bb7ca05ed2b2c94e4339"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="65e66089983763430acea7f4"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="651b10d3ac50ad5b1a5e4232"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="651df6fd8354c435f822a279"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6504b430e0ed27bba405ccdd"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="65139c56a83241ed89ecb04d"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    ".lyvecom_carousel-component >> .swiper-button-next": [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    ".intro__item.flex-col.justify-center:nth-child(1) > .intro__item-icon.overflow-hidden > .intro__item-icon-img": [
      "https://nemah.com/pages/rewards",
    ],
    ".intro__item.flex-col.justify-center:nth-child(1) > .max-sm\\:hidden.intro__item-divider.overflow-hidden > .intro__item-divider-img":
      ["https://nemah.com/pages/rewards"],
    ".intro__item.flex-col.justify-center:nth-child(2) > .intro__item-divider.overflow-hidden > .intro__item-divider-img":
      ["https://nemah.com/pages/rewards"],
    '.lyvecom_carousel-component >> div[data-story-id="651ad59287391b60f4e664ec"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    ".intro__item.flex-col.justify-center:nth-child(3) > .max-sm\\:hidden.intro__item-divider.overflow-hidden > .intro__item-divider-img":
      ["https://nemah.com/pages/rewards"],
    '.lyvecom_carousel-component >> div[data-story-id="65139a648cf4a5023c154c3b"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="6567629865222bf41893c21e"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    '.lyvecom_carousel-component >> div[data-story-id="64db06a94b143c920c68683f"] > .cover-image[loading="lazy"]': [
      "https://nemah.com/pages/gift-guide",
      "https://nemah.com/pages/tracking",
    ],
    ".intro__item.flex-col.justify-center:nth-child(2) > .intro__item-icon.overflow-hidden > .intro__item-icon-img": [
      "https://nemah.com/pages/rewards",
    ],
    ".video-with-text__video > img": ["https://nemah.com/"],
    "video > img": ["https://nemah.com/"],
  };

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split(">>").map((s) => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter((el) => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some((route) => {
      const routeRegex = new RegExp("^" + route.replace(/\*/g, ".*") + "$");
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if (img instanceof HTMLImageElement || img instanceof SVGElement) {
          img.alt = value.alt;

          img.setAttribute("data-alt-added", "fa31c2239fb14d6e8a4b32af7f3968d8");
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", addAltText_fa31c2239fb14d6e8a4b32af7f3968d8);
} else {
  addAltText_fa31c2239fb14d6e8a4b32af7f3968d8();
}

// Rerun the function when the DOM changes
const observer_fa31c2239fb14d6e8a4b32af7f3968d8 = new MutationObserver(() => {
  addAltText_fa31c2239fb14d6e8a4b32af7f3968d8();
});
observer_fa31c2239fb14d6e8a4b32af7f3968d8.observe(document.body, { childList: true, subtree: true });

function fixAccessibility_4745a97466394897aa89fbf35676568f() {
  const targetSelectors = [
    '.restorative-scar-treatment > .rebuy-product-info > .rebuy-product-title.clickable[aria-level="5"]',
    'a[aria-label="View Bath-Time Duo"][aria-level]',
  ];

  function fixElements() {
    let allFixed = true;

    targetSelectors.forEach((selector) => {
      const elements = document.querySelectorAll(selector);
      elements.forEach((element) => {
        if (element.hasAttribute("aria-level")) {
          element.removeAttribute("aria-level");
          element.setAttribute("data-accessibility-fix", "4745a97466394897aa89fbf35676568f");
        }
      });
      if (elements.length === 0) {
        allFixed = false;
      }
    });

    if (allFixed) {
      clearInterval(intervalId);
    }
  }

  const intervalId = setInterval(fixElements, 1000);
}

fixAccessibility_4745a97466394897aa89fbf35676568f();


function fixAccessibility_1d6293bebf66408bb90ca1e08862b594() {
    const interval = setInterval(() => {
        try {
            // Fix for .restorative-scar-treatment > .rebuy-product-info > .rebuy-product-title.clickable[aria-level="5"]
            const scarTreatmentLink = document.querySelector('.restorative-scar-treatment > .rebuy-product-info > .rebuy-product-title.clickable[aria-level="5"]');
            if (scarTreatmentLink && !scarTreatmentLink.hasAttribute('data-accessibility-fix')) {
                const ariaLabel = scarTreatmentLink.getAttribute('aria-label') || 'Restorative Scar Treatment Product';
                scarTreatmentLink.setAttribute('aria-label', ariaLabel);
                scarTreatmentLink.setAttribute('data-accessibility-fix', '1d6293bebf66408bb90ca1e08862b594');
            }

            // Fix for .ql-align-center:nth-child(3) > a[href$="all"]
            const shopNowLink = document.querySelector('.ql-align-center:nth-child(3) > a[href$="all"]');
            if (shopNowLink && !shopNowLink.hasAttribute('data-accessibility-fix')) {
                shopNowLink.setAttribute('aria-label', 'Shop All Products');
                shopNowLink.setAttribute('data-accessibility-fix', '1d6293bebf66408bb90ca1e08862b594');
            }

            // Fix for .revitalizing-stretch-mark-cream > .rebuy-product-info > .rebuy-product-title.clickable[rel="nofollow"]
            const stretchMarkCreamLink = document.querySelector('.revitalizing-stretch-mark-cream > .rebuy-product-info > .rebuy-product-title.clickable[rel="nofollow"]');
            if (stretchMarkCreamLink && !stretchMarkCreamLink.hasAttribute('data-accessibility-fix')) {
                const ariaLabel = stretchMarkCreamLink.getAttribute('aria-label') || 'Revitalizing Stretch Mark Cream Product';
                stretchMarkCreamLink.setAttribute('aria-label', ariaLabel);
                stretchMarkCreamLink.setAttribute('data-accessibility-fix', '1d6293bebf66408bb90ca1e08862b594');
            }

            // Check if all fixes are applied
            if (scarTreatmentLink && shopNowLink && stretchMarkCreamLink) {
                clearInterval(interval);
            }
        } catch (error) {
            console.error('Error applying accessibility fixes:', error);
            clearInterval(interval);
        }
    }, 1000);
}

fixAccessibility_1d6293bebf66408bb90ca1e08862b594();

function fixAccessibility_93e0bd472081493b8a5e00f275b1998f() {
    const interval = setInterval(() => {
        const linkSelector = '.junip-review-grid-item-container:nth-child(1) > .junip-grid-content.junip-p-3 > .junip-review-grid-product-container.junip-mt-3 > a';
        const links = document.querySelectorAll(linkSelector);
        let allFixed = true;

        links.forEach(link => {
            if (!link.hasAttribute('data-accessibility-fix')) {
                // Check if the aria-label is missing or empty
                if (!link.hasAttribute('aria-label') || link.getAttribute('aria-label').trim() === '') {
                    link.setAttribute('aria-label', 'Link to Pregnancy Set product page');
                    link.setAttribute('data-accessibility-fix', '93e0bd472081493b8a5e00f275b1998f');
                } else {
                    allFixed = false;
                }
            }
        });

        if (allFixed) {
            clearInterval(interval);
        }
    }, 1000);

    // Listen for messages from iframes
    window.addEventListener('message', (event) => {
        if (event.data === 'fixAccessibility') {
            fixAccessibility_93e0bd472081493b8a5e00f275b1998f();
        }
    }, false);

    // Send a message to all iframes to apply the fix
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach(iframe => {
        iframe.contentWindow.postMessage('fixAccessibility', '*');
    });
}

// Call the function to initiate the fix
fixAccessibility_93e0bd472081493b8a5e00f275b1998f();

function fixAccessibility_85eeed002eb0470bbd1f1aed81f0b822() {
    const interval = setInterval(() => {
        const elements = document.querySelectorAll('.kl-teaser-SgFRMV:not([data-accessibility-fix="85eeed002eb0470bbd1f1aed81f0b822"])');
        if (elements.length === 0) {
            clearInterval(interval);
            return;
        }

        elements.forEach(element => {
            try {
                // Check if the element is not already wrapped in a section with role='region'
                if (!element.closest('section[role="region"]')) {
                    const section = document.createElement('section');
                    section.setAttribute('role', 'region');
                    section.setAttribute('aria-label', 'Teaser Section');
                    element.parentNode.insertBefore(section, element);
                    section.appendChild(element);
                }

                // Mark the element as fixed
                element.setAttribute('data-accessibility-fix', '85eeed002eb0470bbd1f1aed81f0b822');
            } catch (error) {
                console.error('Error applying accessibility fix:', error);
            }
        });
    }, 1000);

    // Listen for messages from iframes for cross-origin fix application
    window.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'applyAccessibilityFix') {
            fixAccessibility_85eeed002eb0470bbd1f1aed81f0b822();
        }
    });

    // Post message to iframes to apply fix
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach(iframe => {
        try {
            iframe.contentWindow.postMessage({ type: 'applyAccessibilityFix' }, '*');
        } catch (error) {
            console.error('Error sending message to iframe:', error);
        }
    });
}

fixAccessibility_85eeed002eb0470bbd1f1aed81f0b822();


function bubbleHouseRewards(){
if (window.location.pathname !== '/pages/rewards') {

    return;

}

const frame = document.querySelector('#bubblehouse-rewards');

if (!frame) {

    console.error('No iframe found with #bubblehouse-rewards ID.');

    return;

}

frame.title = "Loyalty Rewards"

// This function will hide all child elements by setting aria-hidden="true"

function hideChildren(elem) {

    for (const node of elem.children) {

        node.setAttribute('aria-hidden', 'true');

        node.setAttribute('tabindex', '-1');

        hideChildren(node);

        if (node.tagName.toLowerCase() === 'button') {

          replaceButtonWithDiv(node)
        }
    }

}

function replaceButtonWithDiv(button) {
  // Create a new div
  const div = document.createElement('div');

  // Copy over the button’s children
  while (button.firstChild) {
    div.appendChild(button.firstChild);
  }

  // Copy over any relevant attributes (classes, styles, etc.)
  div.className = button.className;
  div.id = button.id;
  // etc...

  // Replace the button in the DOM
  button.parentNode.replaceChild(div, button);
}

function processIframe() {

    let iframeDoc;

    try {

        iframeDoc = frame.contentDocument || frame.contentWindow.document;

    } catch (e) {

        console.error('Unable to access iframe document, possibly due to cross-origin restrictions.', e);

        return false;

    }

    if (!iframeDoc) {

        console.error('Iframe content document not found.');

        return false;

    }

    const gridWrapper = iframeDoc.querySelector('.earn__area');

    if (!gridWrapper) {

        // Not yet ready

        return false;

    }

    // Ensure a describedby element exists on the main page

    let loginRequired = document.getElementById('login-required');

    if (!loginRequired) {

        loginRequired = document.createElement('span');

        loginRequired.id = 'login-required';

        loginRequired.className = 'visually-hidden';

        loginRequired.textContent = 'Login required to perform this action.';

        document.body.appendChild(loginRequired);

    }

    // Loop through each child element in .earn__area

    for (const child of gridWrapper.children) {

        if (child.tagName.toLowerCase() === 'a') {

            // Extract title and points to build a descriptive label

            const titleEl = child.querySelector('.earn__item-title');

            const pointsEl = child.querySelector('.earn__item-points');

            const titleText = titleEl ? titleEl.textContent.trim() : 'Action';

            const pointsText = pointsEl ? pointsEl.textContent.trim() : '';

            // Construct the full accessible name

            const fullLabel = [titleText, pointsText].filter(Boolean).join(' ');

            // Set aria attributes on the anchor

            child.setAttribute('aria-label', fullLabel);

            child.setAttribute('aria-describedby', 'login-required');

            // Hide all internal elements so only the aria-label is read

            hideChildren(child);

        }

    }

    return true; // Processing done successfully

}

// Poll every 500ms until iframe is ready

const intervalId = setInterval(() => {

    if (processIframe()) {

        clearInterval(intervalId); // Stop polling once processed

    }

}, 500)}

bubbleHouseRewards();

function fixOnwardLabel(){
const pollInterval = setInterval(() => {
    const label = document.querySelector('label[for="insuranceToggle"]');
    if (label) {
      // Create a new span with hidden text:
      const hiddenSpan = document.createElement('span');
      hiddenSpan.classList.add('visually-hidden');
      hiddenSpan.textContent = 'Add Onward insurance';

      // Append it to the label:
      label.appendChild(hiddenSpan);

      // Stop polling once we're done
      clearInterval(pollInterval);
    }
  }, 100);
}

fixOnwardLabel();


function addAltText_92b352cdbc814044a53abf5ab64508c9() {
  const altTextMap = [[".lyvecom_carousel-component >> div[data-story-id=\"65139c56a83241ed89ecb04d\"] > .cover-image[loading=\"lazy\"]",{"selector":".lyvecom_carousel-component >> div[data-story-id=\"65139c56a83241ed89ecb04d\"] > .cover-image[loading=\"lazy\"]","alt":"Person holding a Nemah box, promoting donations to Every Mother Counts and a 15% discount on vegan, safe, and cruelty-free motherhood products."}],[".lyvecom_carousel-component >> .swiper-button-next",{"selector":".lyvecom_carousel-component >> .swiper-button-next","alt":"Next"}],[".lyvecom_carousel-component >> div[data-story-id=\"64da9c03f3c842cf570437cb\"] > .cover-image[loading=\"lazy\"]",{"selector":".lyvecom_carousel-component >> div[data-story-id=\"64da9c03f3c842cf570437cb\"] > .cover-image[loading=\"lazy\"]","alt":"Person with long hair in a doorway, possibly highlighting hairstyle or setting."}],[".lyvecom_carousel-component >> div[data-story-id=\"64da9cf5e8754cfba4e6b307\"] > .cover-image[loading=\"lazy\"]",{"selector":".lyvecom_carousel-component >> div[data-story-id=\"64da9cf5e8754cfba4e6b307\"] > .cover-image[loading=\"lazy\"]","alt":"Person applying Nēmah skincare product to their abdomen, with text overlay reading 'like a line like that.'"}],[".lyvecom_carousel-component >> div[data-story-id=\"64daae7fe9ace09cff473d3f\"] > .cover-image[loading=\"lazy\"]",{"selector":".lyvecom_carousel-component >> div[data-story-id=\"64daae7fe9ace09cff473d3f\"] > .cover-image[loading=\"lazy\"]","alt":"Person displaying a 'Nemah' product, possibly for a review or promotion."}],[".lyvecom_carousel-component >> div[data-story-id=\"651df6fd8354c435f822a279\"] > .cover-image[loading=\"lazy\"]",{"selector":".lyvecom_carousel-component >> div[data-story-id=\"651df6fd8354c435f822a279\"] > .cover-image[loading=\"lazy\"]","alt":"Person in bathroom discussing Nemah Co. revitalizing stretch mark cream."}],[".lyvecom_carousel-component >> div[data-story-id=\"65e66089983763430acea7f4\"] > .cover-image[loading=\"lazy\"]",{"selector":".lyvecom_carousel-component >> div[data-story-id=\"65e66089983763430acea7f4\"] > .cover-image[loading=\"lazy\"]","alt":"Person holding a brown bottle with a dropper labeled 'Nemah', text 'SelfCare with Nemah' visible."}],[".lyvecom_carousel-component >> div[data-story-id=\"65677134d136ef13701198cf\"] > .cover-image[loading=\"lazy\"]",{"selector":".lyvecom_carousel-component >> div[data-story-id=\"65677134d136ef13701198cf\"] > .cover-image[loading=\"lazy\"]","alt":"Person holding a Nēmah skincare bottle, text: clean, non-toxic, vegan, sustainable, developed in Europe, dermatologist approved."}],[".lyvecom_carousel-component >> div[data-story-id=\"651b10d3ac50ad5b1a5e4232\"] > .cover-image[loading=\"lazy\"]",{"selector":".lyvecom_carousel-component >> div[data-story-id=\"651b10d3ac50ad5b1a5e4232\"] > .cover-image[loading=\"lazy\"]","alt":"Person holding a baby; text mentions Nemah and calming peppermint ginger tea."}]];
  const selectorRouteMap = {".contains-nav > .header__logo > .header__logo-link[aria-label=\"Nēmah\"][href=\"/\"] > .regular-logo.loaded.animation--lazy-load > img[width=\"170\"][height=\"40\"][sizes=\"(max-width: 960px) 90px, 100px\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/pages/tracking","https://nemah.com/pages/subscriptions","https://nemah.com/pages/doona-x-nemah-giveaway"],".contains-nav > .header__logo > .header__logo-link[aria-label=\"Nēmah\"][href=\"/\"] > .regular-logo.loaded.animation--lazy-load > img[fetchpriority=\"high\"][width=\"170\"][height=\"40\"]":["https://nemah.com/pages/our-process","https://nemah.com/pages/where-to-find-us","https://nemah.com/pages/our-experts"],".contains-nav > .header__logo > .header__logo-link[aria-label=\"Nēmah\"][href=\"/\"] > .regular-logo.animation--lazy-load.loaded > img[fetchpriority=\"high\"][width=\"170\"][height=\"40\"]":["https://nemah.com/collections/all"],".contains-nav > .header__logo > .header__logo-link[aria-label=\"Nēmah\"][href=\"/\"] > .regular-logo.loaded.image > img[fetchpriority=\"high\"][width=\"170\"][height=\"40\"]":["https://nemah.com/pages/contact-us","https://nemah.com/pages/ambassadors","https://nemah.com/pages/terms-of-service","https://nemah.com/pages/privacy-policy","https://nemah.com/pages/ccpa-opt-out","https://nemah.com/pages/thank-you","https://nemah.com/pages/rewards","https://nemah.com/pages/reviews","https://nemah.com/pages/rewards1","https://nemah.com/pages/kids-happy-hour-giveaway","https://nemah.com/pages/golden-hour-giveaway","https://nemah.com/pages/kemper-baugh","https://nemah.com/pages/alec-treffers","https://nemah.com/pages/haven-nation","https://nemah.com/pages/all-blogs","https://nemah.com/pages/n-mah-rewards","https://nemah.com/pages/scar-stretch","https://nemah.com/pages/cybex-x-nemah-giveaway","https://nemah.com/pages/mothers-day-giveaway","https://nemah.com/pages/brand-perks","https://nemah.com/pages/wholesale","https://nemah.com/pages/accessibility-statement","https://nemah.com/search","https://nemah.com/account/login","https://nemah.com/tools/recurring/get-subscription-access"],".contains-nav > h1 > .header__logo-link[aria-label=\"Nēmah\"][href=\"/\"] > .regular-logo.loaded.animation--lazy-load > img[width=\"170\"][height=\"40\"][sizes=\"(max-width: 960px) 90px, 100px\"]":["https://nemah.com/"],".contains-nav > .header__logo > .header__logo-link[aria-label=\"Nēmah\"][href=\"/\"] > .regular-logo.loaded.image > img[width=\"170\"][height=\"40\"][sizes=\"(max-width: 960px) 90px, 100px\"]":["https://nemah.com/pages/about-us","https://nemah.com/pages/baby-shower","https://nemah.com/blogs/all-blogs/celebrating-nemahs-feature-in-poosh-a-journey-of-love-and-care","https://nemah.com/products/revitalizing-stretch-mark-cream"],"a[aria-label=\"Renewing Nipple + Lip Balm\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"600\"][height=\"750\"][alt=\"Nemah Image Alt Text\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],"img[width=\"1440\"]":["https://nemah.com/collections/all"],"button[data-thumbnail-id=\"26838382117018\"] > .product-thumbnails__item-image.aspect-ratio--portrait.loaded > img[width=\"600\"][height=\"750\"][sizes=\"\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],".multi-column__grid-item.carousel__slide.swiper-slide:nth-child(3) > .multi-column__grid-item-inner > .multi-column__grid-item-icon-wrapper > .multi-column__grid-item-icon.loaded.animation--lazy-load > img[width=\"60\"][height=\"60\"][srcset=\"\"]":["https://nemah.com/pages/subscriptions"],".multi-column__grid-item.carousel__slide.swiper-slide:nth-child(1) > .multi-column__grid-item-inner > .multi-column__grid-item-icon-wrapper > .multi-column__grid-item-icon.loaded.animation--lazy-load > img[width=\"60\"][height=\"60\"][srcset=\"\"]":["https://nemah.com/pages/subscriptions"],".multi-column__grid-item.carousel__slide.swiper-slide:nth-child(2) > .multi-column__grid-item-inner > .multi-column__grid-item-icon-wrapper > .multi-column__grid-item-icon.loaded.animation--lazy-load > img[width=\"60\"][height=\"60\"][srcset=\"\"]":["https://nemah.com/pages/subscriptions"],"img[width=\"3168\"]":["https://nemah.com/pages/about-us"],".product-item.product-item--border-on-hover.animation--item:nth-child(18) > .product-item__inner > .product-item__media--multiple-images.product-item__media > .product-item__image-link > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"4189\"][height=\"5236\"][alt=\"\"]":["https://nemah.com/collections/all"],"img[width=\"427\"]":["https://nemah.com/collections/all"],"a[aria-label=\"Nourishing Belly Oil\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/","https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],".product-item--with-hover-chips > .product-item__inner > .product-item__media--multiple-images.product-item__media > .product-item__image-link > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/collections/all"],"img[width=\"1412\"]":["https://nemah.com/pages/back-to-school-giveaway"],".product-thumbnails__item-image.aspect-ratio--portrait.loaded > img[height=\"1501\"][sizes=\"\"][width=\"1200\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"img[width=\"2409\"]":["https://nemah.com/collections/all"],"img[alt=\"The Everything Set - Family\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],".image-hero-split-item__image.image--animate.loaded:nth-child(2) > img[width=\"3648\"][height=\"5472\"][alt=\"\"]":["https://nemah.com/"],"img[width=\"998\"]":["https://nemah.com/collections/all"],"img[alt=\"science icon\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"a[aria-label=\"Calming Aromatherapy Roll-On\"] > .product-item__image--one.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],".swiper-slide-duplicate.gallery-carousel__item[data-swiper-slide-index=\"3\"]:nth-child(4) > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"700\"][height=\"700\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-visible.gallery-carousel__item[data-swiper-slide-index=\"3\"] > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"700\"][height=\"700\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-duplicate.gallery-carousel__item[data-swiper-slide-index=\"3\"]:nth-child(14) > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"700\"][height=\"700\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],"a[aria-label=\"Bath-Time Duo Refill Set\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"4189\"][height=\"5236\"][alt=\"\"]":["https://nemah.com/collections/all"],"img[sizes=\"100vw\"]":["https://nemah.com/pages/tracking"],"img[alt=\"New Mom Set\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],".image-with-text-split--image-position-left > .image-with-text-split__inner > .image-with-text-split__image-container > .image-with-text-split__image.image--animate.aspect-ratio--square > img[width=\"1000\"][sizes=\"(min-width: 960px) 50vw, 100vw\"][height=\"1000\"]":["https://nemah.com/"],"a[aria-label=\"Nourishing Baby Wash & Shampoo\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/","https://nemah.com/pages/gift-guide","https://nemah.com/pages/doona-x-nemah-giveaway","https://nemah.com/collections/all"],"img[width=\"2240\"]":["https://nemah.com/"],"a[aria-label=\"Baby Shower Gift Set\"] > .product-item__image--one.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/collections/all"],"img[alt=\"Restorative Scar Treatment\"]":["https://nemah.com/","https://nemah.com/pages/gift-guide","https://nemah.com/pages/tracking","https://nemah.com/pages/subscriptions","https://nemah.com/collections/all"],"img[height=\"1501\"][sizes=\"56vw\"][width=\"1200\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"a[aria-label=\"Nourishing Belly Oil\"] > .product-item__image--one.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/","https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],"img[sizes=\"(min-width: 960px) 50vw, 100vw\"]":["https://nemah.com/pages/subscriptions"],"img[height=\"1350\"]":["https://nemah.com/blogs/all-blogs/celebrating-nemahs-feature-in-poosh-a-journey-of-love-and-care"],"img[width=\"1800\"]":["https://nemah.com/pages/baby-shower"],".featured-collection-grid__product.carousel_slide.swiper-slide:nth-child(1) > .product-item.product-item--border-on-hover.animation > .product-item__inner > .product-item__media.product-item__media--multiple-images > .product-item__image-link[aria-label=\"Pregnancy Set\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/"],".swiper-slide-visible.featured-collection-slider__product.carousel__slide:nth-child(4) > .product-item.product-item--border-on-hover.animation > .product-item__inner > .product-item__media.product-item__media--multiple-images > .product-item__image-link[aria-label=\"Pregnancy Set\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/"],".product-item__image--two.product-item__image.aspect-ratio--portrait > img[height=\"1500\"][alt=\"Nemah Image Alt Text\"][width=\"1200\"]":["https://nemah.com/pages/tracking","https://nemah.com/pages/subscriptions"],"a[aria-label=\"Pregnancy Set\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],"a[aria-label=\"Kids Detangling Brush\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/collections/all"],"a[aria-label=\"Renewing Nipple + Lip Balm\"] > .product-item__image--one.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],".image-with-text-split--image-position-right > .image-with-text-split__inner > .image-with-text-split__image-container > .image-with-text-split__image.image--animate.aspect-ratio--square > img[width=\"1000\"][sizes=\"(min-width: 960px) 50vw, 100vw\"][height=\"1000\"]":["https://nemah.com/"],".swiper-slide-duplicate.gallery-carousel__item[data-swiper-slide-index=\"2\"]:nth-child(13) > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"1000\"][height=\"1250\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-duplicate.gallery-carousel__item[data-swiper-slide-index=\"2\"]:nth-child(3) > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"1000\"][height=\"1250\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-visible.gallery-carousel__item[data-swiper-slide-index=\"2\"] > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"1000\"][height=\"1250\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-duplicate-next.swiper-slide-duplicate[data-swiper-slide-index=\"1\"]:nth-child(12) > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"700\"][height=\"700\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-next.swiper-slide-visible[data-swiper-slide-index=\"1\"] > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"700\"][height=\"700\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-duplicate-next.swiper-slide-duplicate[data-swiper-slide-index=\"1\"]:nth-child(2) > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"700\"][height=\"700\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],"a[aria-label=\"Postpartum Set\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/","https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],"img[alt=\"high icon\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"img[alt=\"Bath-Time Duo\"]":["https://nemah.com/pages/doona-x-nemah-giveaway","https://nemah.com/collections/all"],"button[data-thumbnail-id=\"25880994971802\"] > .product-thumbnails__item-image.aspect-ratio--portrait.loaded > img[width=\"600\"][height=\"750\"][sizes=\"\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"img[width=\"1920\"]":["https://nemah.com/pages/subscriptions"],"a[aria-label=\"New Mom Set\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/","https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],"a[aria-label=\"Soothing Baby Lotion\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/pages/doona-x-nemah-giveaway","https://nemah.com/collections/all"],"img[height=\"1501\"]":["https://nemah.com/","https://nemah.com/pages/gift-guide","https://nemah.com/pages/tracking","https://nemah.com/pages/subscriptions","https://nemah.com/collections/all"],".product-thumbnails__item-image.aspect-ratio--portrait.loaded > img[width=\"540\"][height=\"483\"][sizes=\"\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"img[height=\"1080\"]":["https://nemah.com/"],".product-item__image--one.product-item__image.aspect-ratio--portrait > img[height=\"1500\"][alt=\"Nemah Image Alt Text\"][width=\"1200\"]":["https://nemah.com/pages/tracking","https://nemah.com/pages/subscriptions"],".featured-collection-grid__product.carousel_slide.swiper-slide:nth-child(1) > .product-item.product-item--border-on-hover.animation > .product-item__inner > .product-item__media.product-item__media--multiple-images > .product-item__image-link[aria-label=\"Pregnancy Set\"] > .product-item__image--one.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/"],".swiper-slide-visible.featured-collection-slider__product.carousel__slide:nth-child(4) > .product-item.product-item--border-on-hover.animation > .product-item__inner > .product-item__media.product-item__media--multiple-images > .product-item__image-link[aria-label=\"Pregnancy Set\"] > .product-item__image--one.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/"],"a[aria-label=\"Pregnancy Set\"] > .product-item__image--one.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],"img[width=\"1750\"]":["https://nemah.com/"],"img[width=\"3072\"]":["https://nemah.com/pages/doona-x-nemah-giveaway"],"img[width=\"800\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"button[data-thumbnail-id=\"29432979685530\"] > .product-thumbnails__item-image.aspect-ratio--portrait.loaded > img[height=\"1500\"][sizes=\"\"][width=\"1200\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"img[width=\"1256\"]":["https://nemah.com/collections/all"],"img[alt=\"Perents logo\"]":["https://nemah.com/"],".featured-collection-grid__product.carousel_slide.swiper-slide:nth-child(2) > .product-item.product-item--border-on-hover.animation > .product-item__inner > .product-item__media.product-item__media--multiple-images > .product-item__image-link > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"600\"][height=\"750\"][alt=\"Nemah Image Alt Text\"]":["https://nemah.com/pages/gift-guide"],"img[width=\"600\"]":["https://nemah.com/","https://nemah.com/pages/tracking","https://nemah.com/pages/subscriptions"],".product-item.product-item--border-on-hover.animation--item:nth-child(2) > .product-item__inner > .product-item__media--multiple-images.product-item__media > .product-item__image-link > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"600\"][height=\"750\"][alt=\"Nemah Image Alt Text\"]":["https://nemah.com/collections/all"],"a[aria-label=\"Baby Shower Gift Set\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"720\"][height=\"1280\"][alt=\"\"]":["https://nemah.com/collections/all"],"a[aria-label=\"Bath-Time Duo\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/pages/doona-x-nemah-giveaway","https://nemah.com/collections/all"],"a[aria-label=\"Belly Oil Travel Set\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"720\"][height=\"1280\"][alt=\"\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],"img[width=\"720\"]":["https://nemah.com/"],"img[width=\"542\"]":["https://nemah.com/pages/about-us"],"img[alt=\"Kids Headband\"]":["https://nemah.com/collections/all"],"img[width=\"1000\"]":["https://nemah.com/pages/about-us"],"img[width=\"1250\"]":["https://nemah.com/collections/all"],"img[width=\"1080\"][height=\"1080\"][alt=\"\"]":["https://nemah.com/pages/about-us"],"img[width=\"96\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"a[aria-label=\"Bath-Time Trio\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"853\"][height=\"1280\"][alt=\"\"]":["https://nemah.com/","https://nemah.com/collections/all"],".featured-collection-slider__product.carousel__slide.swiper-slide:nth-child(6) > .product-item.product-item--border-on-hover.animation > .product-item__inner > .product-item__media.product-item__media--multiple-images > .product-item__image-link > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"853\"][height=\"1280\"][alt=\"\"]":["https://nemah.com/"],"img[width=\"853\"]":["https://nemah.com/pages/tracking","https://nemah.com/pages/subscriptions","https://nemah.com/pages/doona-x-nemah-giveaway"],".product-item.product-item--border-on-hover.animation--item:nth-child(1) > .product-item__inner > .product-item__media--multiple-images.product-item__media > .product-item__image-link > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"853\"][height=\"1280\"][alt=\"\"]":["https://nemah.com/collections/all"],".featured-collection-grid__product.carousel_slide.swiper-slide:nth-child(1) > .product-item.product-item--border-on-hover.animation > .product-item__inner > .product-item__media.product-item__media--multiple-images > .product-item__image-link > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"853\"][height=\"1280\"][alt=\"\"]":["https://nemah.com/pages/gift-guide"],"button[data-thumbnail-id=\"28652705218714\"] > .product-thumbnails__item-image.aspect-ratio--portrait.loaded > img[width=\"600\"][height=\"750\"][sizes=\"\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"img":["https://nemah.com/pages/wholesale"],"button[data-thumbnail-id=\"29432979751066\"] > .product-thumbnails__item-image.aspect-ratio--portrait.loaded > img[height=\"1500\"][sizes=\"\"][width=\"1200\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"a[aria-label=\"Calming Aromatherapy Roll-On\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/collections/all"],"img[alt=\"\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/pages/gift-guide"],"button[data-thumbnail-id=\"29432964743322\"] > .product-thumbnails__item-image.aspect-ratio--portrait.loaded > img[height=\"1500\"][sizes=\"\"][width=\"1200\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"a[aria-label=\"Soothing Baby Lotion Refill\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"2961\"][height=\"3701\"][alt=\"\"]":["https://nemah.com/collections/all"],".product-item.product-item--border-on-hover.animation--item:nth-child(27) > .product-item__inner > .product-item__media--multiple-images.product-item__media > .product-item__image-link > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"2961\"][height=\"3701\"][alt=\"\"]":["https://nemah.com/collections/all"],"img[height=\"1920\"]":["https://nemah.com/","https://nemah.com/pages/tracking","https://nemah.com/pages/subscriptions","https://nemah.com/collections/all"],".product-item__image--two.product-item__image.aspect-ratio--portrait > img[height=\"1920\"][width=\"1080\"][alt=\"\"]":["https://nemah.com/pages/gift-guide"],"img[width=\"2000\"]":["https://nemah.com/pages/back-to-school-giveaway"],"img[width=\"902\"]":["https://nemah.com/pages/doona-x-nemah-giveaway"],"img[alt=\"Postpartum Set\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],"a[aria-label=\"Every Mother Counts Cotton Hat\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/collections/all"],"img[alt=\"Bath-Time Trio\"]":["https://nemah.com/","https://nemah.com/collections/all"],".swiper-slide-duplicate-active.swiper-slide-duplicate[data-swiper-slide-index=\"0\"]:nth-child(11) > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"1000\"][height=\"1250\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-duplicate-active.swiper-slide-duplicate[data-swiper-slide-index=\"0\"]:nth-child(1) > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"1000\"][height=\"1250\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-active.swiper-slide-visible[data-swiper-slide-index=\"0\"] > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[width=\"1000\"][height=\"1250\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],"img[alt=\"strict icon\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],"a[aria-label=\"The Everything Set - Family\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],"a[aria-label=\"The Everything Gift Set\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[alt=\"Nemah Image Alt Text\"][height=\"1500\"][width=\"1200\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/collections/all"],".swiper-slide-duplicate.gallery-carousel__item[data-swiper-slide-index=\"4\"]:nth-child(15) > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[height=\"1500\"][width=\"1200\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-prev.swiper-slide-duplicate[data-swiper-slide-index=\"4\"] > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[height=\"1500\"][width=\"1200\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],".swiper-slide-duplicate-prev > .gallery-item.gallery-item--label-overlay.gallery-item--label-background-gradient > .gallery-item__image-wrapper.hover > .gallery-item__image.aspect-ratio--square.loaded > img[height=\"1500\"][width=\"1200\"][alt=\"\"]":["https://nemah.com/pages/baby-shower"],"a[aria-label=\"The Velvet Beauty Bag\"] > .product-item__image--two.product-item__image.aspect-ratio--portrait > img[width=\"720\"][height=\"1280\"][alt=\"\"]":["https://nemah.com/collections/all"],".lyvecom_carousel-component >> div[data-story-id=\"65139c56a83241ed89ecb04d\"] > .cover-image[loading=\"lazy\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/pages/tracking"],".lyvecom_carousel-component >> .swiper-button-next":["https://nemah.com/"],".lyvecom_carousel-component >> div[data-story-id=\"64da9c03f3c842cf570437cb\"] > .cover-image[loading=\"lazy\"]":["https://nemah.com/products/revitalizing-stretch-mark-cream"],".lyvecom_carousel-component >> div[data-story-id=\"64da9cf5e8754cfba4e6b307\"] > .cover-image[loading=\"lazy\"]":["https://nemah.com/pages/baby-shower","https://nemah.com/products/revitalizing-stretch-mark-cream"],".lyvecom_carousel-component >> div[data-story-id=\"64daae7fe9ace09cff473d3f\"] > .cover-image[loading=\"lazy\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/pages/tracking"],".rebuy-product-image.clickable[rel=\"nofollow\"] > img[alt=\"Nemah Image Alt Text\"][loading=\"lazy\"]":["https://nemah.com/"],".restorative-scar-treatment > .rebuy-product-media > .rebuy-product-image.clickable[rel=\"nofollow\"] > img[loading=\"eager\"]":["https://nemah.com/"],"img[loading=\"eager\"][alt=\"Nemah Image Alt Text\"]":["https://nemah.com/"],".lyvecom_carousel-component >> div[data-story-id=\"651df6fd8354c435f822a279\"] > .cover-image[loading=\"lazy\"]":["https://nemah.com/","https://nemah.com/products/revitalizing-stretch-mark-cream"],".swiper-slide-duplicate-prev > .quote__item-inner > .quote__item-logo-wrapper > .quote__item-logo.loaded.animation--lazy-load > img[alt=\"glossy logo\"][width=\"178\"][height=\"21\"]":["https://nemah.com/"],".swiper-slide-prev[data-swiper-slide-index=\"0\"][data-index=\"0\"] > .quote__item-inner > .quote__item-logo-wrapper > .quote__item-logo.loaded.animation--lazy-load > img[alt=\"glossy logo\"][width=\"178\"][height=\"21\"]":["https://nemah.com/"],".lyvecom_carousel-component >> div[data-story-id=\"65e66089983763430acea7f4\"] > .cover-image[loading=\"lazy\"]":["https://nemah.com/"],".lyvecom_carousel-component >> div[data-story-id=\"65677134d136ef13701198cf\"] > .cover-image[loading=\"lazy\"]":["https://nemah.com/pages/baby-shower"],".lyvecom_carousel-component >> div[data-story-id=\"651b10d3ac50ad5b1a5e4232\"] > .cover-image[loading=\"lazy\"]":["https://nemah.com/pages/gift-guide","https://nemah.com/pages/tracking"]};

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split('>>').map(s => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter(el => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some(route => {
      const routeRegex = new RegExp('^' + route.replace(/\*/g, '.*') + '$');
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if (img instanceof HTMLImageElement || img instanceof SVGElement) {
          
          img.alt = value.alt;
          
          img.setAttribute('data-alt-added', '92b352cdbc814044a53abf5ab64508c9');
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addAltText_92b352cdbc814044a53abf5ab64508c9);
} else {
  addAltText_92b352cdbc814044a53abf5ab64508c9();
}

// Rerun the function when the DOM changes
const observer_92b352cdbc814044a53abf5ab64508c9 = new MutationObserver(() => {
  addAltText_92b352cdbc814044a53abf5ab64508c9();
});
observer_92b352cdbc814044a53abf5ab64508c9.observe(document.body, { childList: true, subtree: true });

function updateAriaLabelsForLinks() {
  setInterval(() => {
    // Select all anchor tags on the page
    const links = document.querySelectorAll('a[href*="nemah.com/blogs/stories/"]');

    links.forEach(link => {
      // Check if the text content is 'Read More' and aria-label is not already set
      if (
        link.textContent.trim() === "Read More" &&
        !link.hasAttribute("aria-label")
      ) {
        // Extract the name from the href
        const href = link.getAttribute("href");
        const nameMatch = href.match(/nemah\.com\/blogs\/stories\/([^/]+)/);

        if (nameMatch && nameMatch[1]) {
          const name = decodeURIComponent(nameMatch[1]).replace(/-/g, ' ');
          // Set the aria-label with the desired format
          link.setAttribute("aria-label", `Read More about ${name}`);
        }
      }
    });
  }, 1000);
}

function updateAriaLabelsAndRemoveEmptyLinks() {
  setInterval(() => {
    // Select all anchor tags on the page
    const links = document.querySelectorAll('a');

    links.forEach(link => {
      const href = link.getAttribute("href");

      // If href is empty or missing, remove the link
      if (!href || href.trim() === "") {
        link.remove();
        return; // Skip further checks for this link
      }

      // Process links matching the specified pattern
      if (
        href.includes("nemah.com/blogs/stories/") &&
        link.textContent.trim() === "Read More" &&
        !link.hasAttribute("aria-label")
      ) {
        // Extract the name from the href
        const nameMatch = href.match(/nemah\.com\/blogs\/stories\/([^/]+)/);

        if (nameMatch && nameMatch[1]) {
          const name = decodeURIComponent(nameMatch[1]).replace(/-/g, " ");
          // Set the aria-label with the desired format
          link.setAttribute("aria-label", `Read More about ${name}`);
        }
      }
    });
  }, 1000); // Run every second
}

// Start the function
updateAriaLabelsAndRemoveEmptyLinks();

function manageTabOrderForHiddenElements() {
  setInterval(() => {
    // Select the dynamically changing parent element
    const hiddenElement = document.querySelector('#rebuy-cart[aria-hidden="true"]');

    // Handle the case where aria-hidden="true"
    if (hiddenElement) {
      // Find all focusable children
      const focusableSelectors = 'a, button, input, select, textarea, [tabindex]';
      const focusableChildren = hiddenElement.querySelectorAll(focusableSelectors);

      // Ensure all focusable children are out of tab order
      focusableChildren.forEach(child => {
        if (!child.hasAttribute('data-original-tabindex')) {
          // Store the original tabindex (if any)
          const originalTabIndex = child.getAttribute('tabindex');
          if (originalTabIndex !== null) {
            child.setAttribute('data-original-tabindex', originalTabIndex);
          } else {
            child.setAttribute('data-original-tabindex', 'none');
          }
        }
        // Set tabindex to -1 to remove from tab order
        child.setAttribute('tabindex', '-1');
      });
    }

    // Handle the case where aria-hidden="false"
    const visibleElement = document.querySelector('#rebuy-cart[aria-hidden="false"]');
    if (visibleElement) {
      // Find all children with previously stored tabindex
      const focusableChildren = visibleElement.querySelectorAll('[data-original-tabindex]');

      focusableChildren.forEach(child => {
        const originalTabIndex = child.getAttribute('data-original-tabindex');
        if (originalTabIndex === 'none') {
          // Remove tabindex attribute if it was not set originally
          child.removeAttribute('tabindex');
        } else {
          // Restore the original tabindex value
          child.setAttribute('tabindex', originalTabIndex);
        }
        // Remove the data-original-tabindex attribute
        child.removeAttribute('data-original-tabindex');
      });
    }
  }, 1000); // Poll every second
}

// Start the function
manageTabOrderForHiddenElements();

(function () {
  function fixInvalidAriaAttributes() {
    // Select all elements with aria-label and tabindex
    const elements = document.querySelectorAll('[aria-label][tabindex]');
    
    elements.forEach((el) => {
      const role = el.getAttribute('role');
      const ariaLabel = el.getAttribute('aria-label');
      const isImplicitGeneric = !role || role === 'generic';

      // If the element has an implicit 'generic' role, fix it
      if (isImplicitGeneric) {
        // Check if the element is intended to be interactive
        if (el.tagName === 'SPAN' || el.tagName === 'DIV') {
          // Make it a button if it seems like an interactive element
          el.setAttribute('role', 'button');
          el.setAttribute('aria-label', ariaLabel); // Keep the label
        } else {
          // If it's not interactive, remove the aria-label
          el.removeAttribute('aria-label');
        }
      }
    });
  }

  // Poll every second to handle dynamically loaded elements
  setInterval(fixInvalidAriaAttributes, 1000);
})();


function toggleGif(button) {
  console.log('toggling gif')
  var container = button.closest('.image');
  if (!container) return;

  console.log(container)

  var img = container.querySelector('img[data-gif]');
  if (!img) return;

  console.log(img)

  var paused = (img.getAttribute('data-paused') === 'true');

  if (paused) {
    // Resume
    img.setAttribute('data-paused', 'false');
    img.src = img.getAttribute('data-original-src');
    img.srcset = img.getAttribute('data-original-srcset')
    button.setAttribute('aria-label', 'Stop the GIF')
    button.innerText = 'Stop';
  } else {
    // Pause
    img.setAttribute('data-paused', 'true');
    img.setAttribute('data-original-srcset', img.srcset)
    img.setAttribute('data-original-src', img.src)
    button.setAttribute('aria-label', 'Start the GIF')
    img.src = '';
    img.srcset = '';
    button.innerText = 'Start';
   }
}

function hideIndividualStars() {
  setInterval(() => {
    // Select all junip-stars-container elements that are not aria-hidden
    const starContainers = document.querySelectorAll('.junip-stars-container:not([aria-hidden="true"])');
    
    starContainers.forEach(container => {
      // Add aria-hidden to the container
      container.setAttribute('aria-hidden', 'true');
      
      // Add aria-hidden to all child elements
      container.querySelectorAll('*').forEach(child => {
        child.setAttribute('aria-hidden', 'true');
      });
    });
  }, 1000); // Check every second
}

// Start the function
hideIndividualStars();

